import { Link } from "react-router-dom"
import "./OfferingItem.css"

const OfferingItem = ({ image, title, description, link }) => {
  return (
    <Link to={link} className="offering-item">
      <div className="offering-image">
        <img src={image || "/placeholder.svg"} alt={title} />
      </div>
      <h3 className="offering-title">{title}</h3>
      <p className="offering-description">{description}</p>
    </Link>
  )
}

export default OfferingItem